//
import { handleActions } from 'redux-actions';
import * as actions from './notificationsActions';
import { mkNotificationsStore } from './notificationsTypes';

const notificationsReducer = handleActions(
  {
    [actions.addNotifications]: (state, { payload: notifications }) => state.mergeDeep({ notifications }),

    [actions.removeNotifications]: (state, { payload: notificationKeys }) =>
      state.merge({ notifications: state.notifications.deleteAll(notificationKeys) }),
  },
  mkNotificationsStore(),
);

export const NOTIFICATIONS_REDUCER_KEY = 'notificationsStore';
export default notificationsReducer;
